/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MealDetails from './meal-details';
import MealDetailsDetail from './meal-details-detail';
import MealDetailsUpdate from './meal-details-update';
import MealDetailsDeleteDialog from './meal-details-delete-dialog';

const MealDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MealDetails />} />
    <Route path="new" element={<MealDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<MealDetailsDetail />} />
      <Route path="edit" element={<MealDetailsUpdate />} />
      <Route path="delete" element={<MealDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MealDetailsRoutes;
